import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ITableSet } from '../../../components/table/Table';
import TableWithPagination from '../../../components/table/tableWithPagination/TableWithPagination';
import { IState } from '../../../redux/store';
import { updateParam } from '../../../redux/progress/param/paramAction'
import useTableDataWithPagination from '../../../components/table/tableWithPagination/useTableDataWithPagination';
import { urls } from '../../../config/url';
import { IDataDirInfo } from './DataDirInfo';
import { IDataFileInfo } from './DataFileInfo';
import { FileViewFetchTrigger } from '../../../components/fileView/FileViewTrigger';
import { fetchFile } from '../../dataView/dataView/dataFileTable/FetchFile';
import getViewType, { FileType } from '../../../components/fileView/FileType';
import { IModuleParams } from '../../../redux/progress/param/paramReducer';
import { IModuleParam } from '../../../redux/progress/module/moduleInterface';

function FilePicker(props: {
    userName: string,
    activeProjectName: string,
    dataInfo: IDataDirInfo;
    close: () => void;
    updateParam: (param: IModuleParams) => void;
    param: IModuleParam;
    onChange?: (value: string) => void;
}) {

    const tableSets: ITableSet[] = [
        {
            titleId: "serial_number",
            cover: rowIndex => <>{rowIndex + 1}</>
        },
        {
            titleId: "file_name_header",
            key: "file_name",
            handleSort: (a, b) => { return a ? b ? a.localeCompare(b, 'zh-CN') : 1 : -1 },
            cover: (rowIndex: number, info: IDataFileInfo) => {
                const filePath = `${info.storepath}${info.relative_file_path}/${info.file_name}`;
                return (
                    <FileViewFetchTrigger
                        name={info.file_name}
                        fetch={() => {
                            return fetchFile(filePath, getViewType(info.type as FileType));
                        }}
                        type={info.type as FileType}
                    >
                        {info.file_name}
                    </FileViewFetchTrigger>
                )
            },
            style: {
                width: "10%"
            }
        },
        {
            titleId: "size_MB",
            key: "size",
            handleSort: (a, b) => { return a ? b ? a.localeCompare(b, 'zh-CN') : 1 : -1 }
        },
        {
            titleId: "create_time",
            key: "create_time",
            handleSort: (a, b) => { return a ? b ? a.localeCompare(b, 'zh-CN') : 1 : -1 }
        },
        {
            titleId: "modification_time",
            key: "modify_time",
            handleSort: (a, b) => { return a ? b ? a.localeCompare(b, 'zh-CN') : 1 : -1 }
        },
        {
            titleId: "empty",
            cover: (rowIndex: number, info: IDataFileInfo) => {
                const filePath = `${info.storepath}${info.relative_file_path}/${info.file_name}`;
                return (
                    <FileViewFetchTrigger
                        name={info.file_name}
                        fetch={() => {
                            return fetchFile(filePath, getViewType(info.type as FileType));
                        }}
                        type={info.type as FileType}
                    >
                        {(viewab1e: boolean) => {
                            return viewab1e ? <>查看</> : <></>
                        }}
                    </FileViewFetchTrigger>
                )
            },
        },
        {
            titleId: "empty",
            cover: (rowIndex: number, dirInfo: IDataFileInfo) => {
                return (
                    <button
                        key={rowIndex}
                        className="btn btn-primary"
                        onClick={() => {
                            props.updateParam({ [props.param.PARAMNAME]: `${dirInfo.storepath}${dirInfo.relative_file_path}/${dirInfo.file_name}` }); // eslint-disable-line
                            props.onChange?.(`${dirInfo.storepath}${dirInfo.relative_file_path}/${dirInfo.file_name}`);
                            props.close();
                        }}
                    >
                        选择
                    </button>
                )

            }
        }
    ];

    const param = useTableDataWithPagination(urls.listUserFileDataByPage, {
        USER_NAME: props.userName,
        PROJECTNAME: props.activeProjectName,
        USERDATADIR_UNIQUEID: props.dataInfo.USERDATADIR_UNIQUEID,
        FIELD_USERDATACLASS: props.dataInfo.FIELD_USERDATACLASS,
        relative_file_path: props.dataInfo.relative_file_path,
        USERDATADIR_NAME:props.dataInfo.USERDATADIR_NAME,
    });

    useEffect(() => {
        param.update();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.dataInfo]);


    return <>
        <TableWithPagination param={param} tableSets={tableSets} />
    </>
}

const mapStateToProps = (state: IState) => {
    return {
        userName: state.user.userName,
        activeProjectName: state.project.activeName
    };
};


export default connect(
    mapStateToProps,
    { updateParam }
)(FilePicker);